import TabsOta from './TabsOta'

export { TabsOta }
